type TOrganizationWithBillingAccount = {
  billingAccountId?: string | null;
  billingAccount?: { id?: string } | null;
};

export function resolveOrganizationBillingAccountId(
  organization: TOrganizationWithBillingAccount | null | undefined,
): string | undefined {
  const id = organization?.billingAccount?.id ?? organization?.billingAccountId ?? undefined;
  return id || undefined;
}
